const url = {
    development: {
        apiUrl: '',
        apiUrlFilter: '/api',
        authUrl: 'https://auth-dev.bnq.com.cn',
        authUrlFilter: '/auth',
        zmAuth: 'https://z-dev.bnq.com.cn/user/login',
        website: 'https://ams-dev.bthome.com',
        port: 8010,
        autoOpenBrowser: true,
        userCenterUrl: 'https://user-center-dev.bnq.com.cn',
        userCenterUrlFilter: '/userCenterAdmin',
        himikoUrl: 'https://himiko-dev.bthome.com',
        authorityUrl: "https://authority-dev.bnq.com.cn",
        authorityFilter: "/authoritySrv",
        salesUrl: 'https://sales-dev.bnq.com.cn',
    },
    prodDev: {
        apiUrl: 'https://ams-dev.bthome.com',
        apiUrlFilter: '/api',
        authUrl: 'https://auth-dev.bnq.com.cn',
        authUrlFilter: '/auth',
        zmAuth: 'https://z-dev.bnq.com.cn/user/login',
        website: 'https://ams-dev.bthome.com',
        himikoUrl: 'https://himiko-dev.bthome.com',
        userCenterUrl: 'https://user-center-dev.bnq.com.cn',
        userCenterUrlFilter: '/userCenterAdmin',
        authorityUrl: "https://authority-dev.bnq.com.cn",
        authorityFilter: "/authoritySrv",
        salesUrl: 'https://sales-dev.bnq.com.cn',
    },
    test: {
        apiUrl: 'https://ams-test.bthome.com',
        apiUrlFilter: '/api',
        authUrl: 'https://auth-test.bnq.com.cn',
        authUrlFilter: '/auth',
        zmAuth: 'https://z-test.bnq.com.cn/user/login',
        website: 'https://ams-test.bthome.com',
        himikoUrl: 'https://himiko-test.bthome.com',
        userCenterUrl: 'https://user-center-test.bnq.com.cn',
        userCenterUrlFilter: '/userCenterAdmin',
        authorityUrl: "https://authority-test.bnq.com.cn",
        authorityFilter: "/authoritySrv",
        salesUrl: 'https://sales-test.bnq.com.cn',
    },
    uat: {
        apiUrl: 'https://ams-uat.bthome.com',
        apiUrlFilter: '/api',
        authUrl: 'https://auth-uat.bnq.com.cn',
        authUrlFilter: '/auth',
        zmAuth: 'https://z-uat.bnq.com.cn/user/login',
        website: 'https://ams-uat.bthome.com',
        userCenterUrl: 'https://user-center-uat.bnq.com.cn',
        userCenterUrlFilter: '/userCenterAdmin',
        authorityUrl: "https://authority-uat.bnq.com.cn",
        authorityFilter: "/authoritySrv",
        salesUrl: 'https://sales-uat.bnq.com.cn',
    },
    production: {
        apiUrl: 'https://ams.bthome.com',
        apiUrlFilter: '/api',
        authUrl: 'https://auth.bnq.com.cn',
        authUrlFilter: '/auth',
        zmAuth: 'https://z.bnq.com.cn/user/login',
        website: 'https://ams.bthome.com',
        himikoUrl: 'https://himiko.bthome.com',
        userCenterUrl: 'https://user-center.bnq.com.cn',
        userCenterUrlFilter: '/userCenterAdmin',
        authorityUrl: "https://authority.bnq.com.cn",
        authorityFilter: "/authoritySrv",
        salesUrl: 'https://item.bnq.com.cn',
    },
};

module.exports = url;
